import Route from "../../types/Route";

export const ROUTES: Array<Route> = [
  {
    title: "Home",
    url: "/",
  },
  {
    title: "About",
    url: "/about",
  },
  {
    title: "Projects",
    url: "/projects",
  },
  {
    title: "Resume",
    url: "/resume",
  },
  {
    title: "Contact",
    url: "/contact",
  },
];
